module.exports = __webpack_public_path__ + "img/slide_5.72d18fd7.png";